import React from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Card, CardActionArea, IconButton, Typography } from '@mui/material';

import useInsuranceInfo from '../../hooks/useInsuranceInfo';
import { formatDate, INSURANCE_TYPE_PETOLO } from '../../shared';
import CaretRightIcon from '../../icons/CaretRightIcon';

import {
  StyledClaimCardContentTextContainer,
  StyledClaimStatus,
  StyledClaimCardContent,
} from './ClaimStatus.styled';

const ClaimStatus = ({ claim, setSelectedClaim }) => {
  const {
    id,
    key,
    status,
    treatmentCategory,
    statusDetails,
    notificationDate,
    lossDate,
    statusUpdated,
  } = claim;

  const history = useHistory();
  const intl = useIntl();

  const { type: insuranceType } = useInsuranceInfo();
  const isPetolo = insuranceType === INSURANCE_TYPE_PETOLO;

  const handleClaimStatusClick = () => {
    setSelectedClaim({
      statusUpdated,
      notificationDate,
      treatmentCategory,
      statusDetails,
      lossDate,
      status,
      id,
      key,
    });

    history.push(`/user-claims-info/${id}`);
  };

  return (
    <Card elevation={1}>
      <CardActionArea
        onClick={handleClaimStatusClick}
        aria-label={`${intl.formatMessage({ id: `treatment.category.${treatmentCategory}` })} - ${key}`}
      >
        <StyledClaimCardContent statusUpdated={statusUpdated}>
          <StyledClaimCardContentTextContainer>
            {!!treatmentCategory && (
              <Typography variant="h3">
                <FormattedMessage id={`treatment.category.${treatmentCategory}`} />
              </Typography>
            )}

            {isPetolo && !treatmentCategory && (
              <Typography variant="h3">
                <FormattedMessage id="treatment.category.pet_null" />
              </Typography>
            )}

            <Typography variant="p" color="professional_light_blue" data-hj-suppress="true">
              {formatDate(lossDate || notificationDate)} ({key})
            </Typography>

            <StyledClaimStatus claimStatus={status}>
              <Typography variant="p">
                <FormattedMessage id={`claim.status.label.${status}`} />
              </Typography>
            </StyledClaimStatus>
          </StyledClaimCardContentTextContainer>

          <IconButton
            variant="round"
            onClick={(e) => {
              e.stopPropagation();
              handleClaimStatusClick();
            }}
            aria-label="go to claim details"
          >
            <CaretRightIcon />
          </IconButton>
        </StyledClaimCardContent>
      </CardActionArea>
    </Card>
  );
};

ClaimStatus.propTypes = {
  setSelectedClaim: PropTypes.func,
  claim: PropTypes.shape({
    id: PropTypes.number,
    key: PropTypes.string,
    status: PropTypes.string,
    treatmentCategory: PropTypes.string,
    statusDetails: PropTypes.string,
    notificationDate: PropTypes.string,
    lossDate: PropTypes.string,
    statusUpdated: PropTypes.bool,
  }).isRequired,
};

export default ClaimStatus;
